import { Injectable } from '@angular/core';
import { CalendarUtilsService } from './calendar-utils.service';
import { GoogleCalendarService } from './google-calendar.service';
import { newCalendarEvent } from '../../models/calendar-model';
import { DbAppointmentsService } from './db-appointments.service';

@Injectable({
  providedIn: 'root',
})
export class CalendarOrchestratorService {
  constructor(
    private calendarUtilsService: CalendarUtilsService,
    private googleCalendarService: GoogleCalendarService,
    private dbAppointmentsService: DbAppointmentsService
  ) {}

  // This method orchestrates the creation of event in both systems
  addNewEvent(newEvent: newCalendarEvent): Promise<any> {
    return new Promise((resolve, reject) => {
      this.googleCalendarService
        .addEventToGoogleCalendar(newEvent)
        .then((googleResponse) => {
          if (newEvent.isAppointment) {
            return this.dbAppointmentsService.addAppointmentToDb(
              newEvent,
              googleResponse.result.id
            );
          }
          return googleResponse;
        })
        .then((finalResponse) => {
          resolve(finalResponse);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
